import { z } from 'zod';

export const EXAMPLE_APP_DOMAINS = [
  'general',
  'finance',
  'medicine',
  'vacation-rental',
  'taxes',
] as const;

export const ExampleAppDomainSchema = z.enum(EXAMPLE_APP_DOMAINS);

export type ExampleAppDomain = z.infer<typeof ExampleAppDomainSchema>;

export const EXAMPLE_APP_DOMAIN_LABELS: Record<ExampleAppDomain, string> = {
  general: 'General',
  finance: 'Finance',
  medicine: 'Medicine',
  'vacation-rental': 'Vacation Rental',
  taxes: 'Taxes',
};
